import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetaPixelEvent } from '../lib/metaPixel';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    const currentUrl = window.location.origin + pathname + search;

    // Track dynamic page view in Google Analytics (gtag)
    if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', 'page_view', {
        page_path: pathname + search,
        page_title: document.title,
        page_location: currentUrl
      });
    }

    // Track dynamic page view in Google Tag Manager (dataLayer)
    if (typeof (window as any).dataLayer !== 'undefined') {
      (window as any).dataLayer.push({
        event: 'page_view',
        page_path: pathname + search,
        page_title: document.title,
        page_location: currentUrl
      });
    }

    // Track dynamic page view in Meta Pixel
    trackMetaPixelEvent('PageView');
  }, [pathname, search]);

  return null;
}
